import React from 'react';

const Carretera = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Caaretera</h1>
      <p>This is the Carretera service page under Inovaantage.</p>
    </div>
  );
};

export default Carretera;
